import i from 'icepick'
import { flow, map, orderBy } from 'lodash/fp'
import { keyBy, camelCase } from 'lodash'
import analytics from 'features/Analytics/Analytics.utils'

const initialState = {
  casesById: {},
  cases: [],

  serviceCases: {},
  serviceCasesLoading: {},

  outages: {
    phoneNumbers: {
      severity: 'Sev 0',
      impact: undefined, // "Partial Loss" || 'Total Loss'
    },
    phoneSystem: {},
    flows: {},
    internet: {},
  },
  getCasesLoading: false,
  getOutagesLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CASES/GET_CASES_PENDING':
      return i.assoc(state, 'getCasesLoading', true)
    case 'CASES/GET_CASES_REJECTED':
      return i.assoc(state, 'getCasesLoading', false)
    case 'CASES/GET_CASES_FULFILLED':
      return i
        .chain(state)
        .assoc('cases', flow(orderBy(['modifiedAt'], ['desc']), map('id'))(action.payload.data))
        .updateIn(['casesById'], casesById => ({
          ...casesById,
          ...keyBy(action.payload.data, 'id'),
        }))
        .assoc('getCasesLoading', false)
        .value()

    case 'CASES/GET_TROUBLE_TICKET_FULFILLED':
      return i
        .chain(state)
        .assocIn(['casesById', action.payload.data.case.id], {
          ...action.payload.data.case,
          troubleTicket: action.payload.data.troubleTicket,
        })
        .value()

    case 'CASES/ADD_TROUBLE_TICKET_NOTE_FULFILLED':
      return i
        .chain(state)
        .assocIn(['casesById', action.payload.data.case.id], {
          ...action.payload.data.case,
          troubleTicket: action.payload.data.troubleTicket,
        })
        .value()

    case 'CASES/GET_OUTAGES_PENDING':
      return i.assoc(state, 'getOutagesLoading', true)
    case 'CASES/GET_OUTAGES_REJECTED':
      return i.assoc(state, 'getOutagesLoading', false)
    case 'CASES/GET_OUTAGES_FULFILLED':
      return i
        .chain(state)
        .updateIn(['outages'], outages => ({
          ...outages,
          ...action.payload.data.reduce((accum, outage) => {
            const servicesAffected = outage.servicesAffected.split(';')
            const outageValue = {
              severity: outage.severity,
              impact: outage.impact,
            }
            servicesAffected.forEach(serviceName => {
              accum[camelCase(serviceName)] = outageValue
            })
            return accum
          }, {}),
        }))
        .assoc('getOutagesLoading', false)
        .value()

    case 'CASES/GET_SERVICE_CASES_PENDING':
      return i.assocIn(state, ['serviceCasesLoading', action.meta.serviceId], true)
    case 'CASES/GET_SERVICE_CASES_REJECTED':
      return i.assocIn(state, ['serviceCasesLoading', action.meta.serviceId], false)
    case 'CASES/GET_SERVICE_CASES_FULFILLED':
      return i
        .chain(state)
        .assocIn(
          ['serviceCases', action.meta.serviceId],
          action.payload.data.map(item => item.id)
        )
        .updateIn(['casesById'], casesById => ({
          ...casesById,
          ...keyBy(action.payload.data, 'id'),
        }))
        .assoc('serviceCasesLoading', false)
        .value()

    case 'CASES/CREATE_BILLING_DISPUTE_FULFILLED':
      analytics.track('Cases - Billing Dispute - Create', action.payload.data)
      return state
    case 'CASES/CREATE_TROUBLE_TICKET_FULFILLED':
      analytics.track('Cases - Trouble Ticket - Create', action.payload.data)
      return state
    case 'CASES/CREATE_ENQUIRY_FULFILLED':
      analytics.track('Cases - Billing Enquiry - Create', action.payload.data)
      return state

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/Cases.reducer.js